import AppleStore from '~/assets/icons/apple-store';
import GooglePlay from '~/assets/icons/google-play';
import { Icons } from '~/components/Icon/constants';

export const getPlatformIcon = (
  platform: string,
): typeof AppleStore | typeof GooglePlay | undefined => {
  switch (platform) {
    case 'appleStore':
      return AppleStore;
    case 'googlePlay':
      return GooglePlay;
  }
};

export const getSocialIcon = (platform: string): Icons | undefined => {
  switch (platform) {
    case 'twitter':
      return Icons.XLogo;
    case 'facebook':
      return Icons.Facebook;
    case 'youTube':
      return Icons.YouTube;
    case 'instagram':
      return Icons.Instagram;
  }
};
